import '../Dialog.css';
import './AirportDialog.css';

import React, { Component } from 'react';
import { Divider, Drawer, ListItem, ListItemText, ListItemIcon, TableRow, TableCell, Icon, IconButton } from '@material-ui/core';
import Axios from 'axios';
import CloseIcon      from '@material-ui/icons/Close';
import LineWeightIcon from '@material-ui/icons/LineWeight';

import Units    from '../../tools/Units.js';
import RunwayTable from './RunwayTable/RunwayTable';
import AirspaceTable from './AirspaceTable/AirspaceTable';
import { Fragment } from 'react';

const URL_BASE = 'https://api3.private-radar.com/openaip';
const URL_GET_AIRPORT = `${URL_BASE}/Airport/GetById?getAirspaces=true&idOpenAip=`;
const LAT = '{LAT}';
const LON = '{LON}';
const URL_GET_AIRSPACES = `${URL_BASE}/Airspace/GetLatLon?lat=${LAT}&lon=${LON}`;

export default class AirportDialog extends Component {
	state = {
		open: false,
		airport: null,
		airspaces : [],
	}

	componentDidMount() {
		this.initEventListener();
	}

	initEventListener() {
		// Listen for click on airport
		window.addEventListener('airportClick', (e) => {
			this.loadAirport(e.detail);
		}, false);

		// Listen for click on airspace
		window.addEventListener('airspaceClick', (e) => {
			let lat = e.detail.lat;
			let lon = e.detail.lon;
			
			this.loadAirspaces(lat, lon);
		}, false);
	}

	// Load Airports
	async loadAirport (idAirport) {
		// Get
		let url = URL_GET_AIRPORT + idAirport;
		const res = await Axios.get(url);

		// Error
		if (res.status !== 200) {
			// Deal with the error
			console.error('loadAirports error ' + res.error);
			return;
		}

		// Success
		let airport = res.data.airport;
		let airspaces = res.data.airspaces;
		// airspaces = airspaces.sort((a,b) => a.altLimitTop.alt -b.altLimitTop.alt )
		this.setState({airport, airspaces});
	}

	async loadAirspaces(lat, lon) {
		// Get
		let url = URL_GET_AIRSPACES.replace(LAT, lat).replace(LON, lon);
		const res = await Axios.get(url);

		// Error
		if (res.status !== 200) {
			// Deal with the error
			console.error('loadAirspaces error ' + res.error);
			return;
		}

		// Success
		this.setState({airport:null, airspaces: res.data})
	}


	openTab = (e) => {
		let property = e.currentTarget.name;
		this.setState({
			[property]: !this.state[property]
		})
	}

	getAirportElevation() {
		const airport = this.state.airport;
		if (!airport || !airport.elevation)
			return '';

		return `${Units.metersToFeet(airport.elevation)} ft`;
	}

	render() {
		let { open, squishContent } = this.props;
		let { airport, airspaces } = this.state;
		
		return (
			<Drawer transitionDuration={300} variant="persistent" onBackdropClick={this.handleClose} open={open} className={squishContent}>
				<div id="AirportDialog"  >
					<div className="top">
						<IconButton className="closeDialog" onClick={this.props.onClose}>
							<CloseIcon edge="end" className="dialogIcon"></CloseIcon>
						</IconButton>
					</div>
			
					{/* Airport info  */}
					{airport && 
						<Fragment>
							<div className="dialogTitle">
								<h2>{airport.name || ''}</h2>
								<h5>{airport.icaoCode || ''}</h5>
								<h5>{this.getAirportElevation()}</h5>
							</div>
						
							{/* Runways  */}
							<div className="runwaysHead" >
							<Divider></Divider>

								<ListItem className="dialogListTitle">
									<ListItemIcon>
										<Icon className='mdi mdi-road-variant dialogIcon'></Icon>
									</ListItemIcon>
									<ListItemText primary="Runways"></ListItemText>
								</ListItem>
								<Divider></Divider>
							</div>

							<div className="runways">
								<RunwayTable runways={airport?.runways} />
							</div>

							{/* Frequencies */}
							{/* <div className="frequenciesHead">
								<ListItem className="dialogListTitle">
									<ListItemIcon>
										<Icon className='mdi mdi-access-point dialogIcon'></Icon>
									</ListItemIcon>
									<ListItemText primary="Frequencies"></ListItemText>
								</ListItem>
								<Divider></Divider>
							</div> */}
							{/* <div className="frequencies">
								<TableContainer className={radioTableAdjuster}>
									<Table stickyHeader >
										<TableHead>
											<TableRow>
												<TableCell>Frequency</TableCell>
												<TableCell>Category</TableCell>
												<TableCell>Type</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{airport?.frequencies?.length > 0 ? airport.frequencies.map((r, i) => {
												return <AirportFrequencyDialog radio={r} />;
											}) : (<AirportFrequencyDialog notAvailable />)
											}
										</TableBody>
									</Table>
								</TableContainer>                
							</div> */}
						</Fragment>
					}

					{/* Airspace */}
					<div className="airspacesHead"> 
						<ListItem className="dialogListTitle">
							<ListItemIcon> 
								<LineWeightIcon className="dialogIcon"></LineWeightIcon>                            
							</ListItemIcon>
							<ListItemText primary="Airspaces"></ListItemText>
						</ListItem>
					</div>
					<div className="airspaces"> 
						<Divider></Divider>
						<AirspaceTable airspaces={airspaces} />
					</div>
				</div>
			</Drawer>
		)
	}
}

function AirportFrequencyDialog(props) {
	if (props.notAvailable)
		return (
			null
		);
	let name = props.radio.frequency;
	let category = props.radio.category;
	if (props.radio.category === 'COMMUNICATION')
		category = 'COM'; 
	let type = props.radio.type;
		return (
			<TableRow>
				<TableCell>{name}</TableCell>
				<TableCell>{category}</TableCell>
				<TableCell>{type}</TableCell>
			</TableRow>
		);
}